export default "/assets/images/the-home-wrecker-crop.png?0d7a1fa19d3894d39cb64f7219af8482";